import { createReducer, on } from '@ngrx/store';
import * as TagsActions from './tags.actions';
import { initialTagsState } from './tags.state';

export const tagsReducer = createReducer(
  initialTagsState,

  on(TagsActions.loadTags, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(TagsActions.loadTagsSuccess, (state, { tags, pagination }) => ({
    ...state,
    tags,
    pagination,
    loading: false,
    error: null,
  })),

  on(TagsActions.loadTagsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(TagsActions.createTag, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(TagsActions.createTagSuccess, (state, { tag }) => ({
    ...state,
    tags: [ ...state.tags, tag ],
    loading: false,
    error: null,
  })),

  on(TagsActions.createTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(TagsActions.updateTag, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(TagsActions.updateTagSuccess, (state, { tag }) => ({
    ...state,
    tags: state.tags.map(t => t.id === tag.id ? tag : t),
    loading: false,
    error: null,
  })),

  on(TagsActions.updateTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(TagsActions.deleteTag, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(TagsActions.deleteTagSuccess, (state, { id }) => ({
    ...state,
    tags: state.tags.filter(t => t.id !== id),
    loading: false,
    error: null,
  })),

  on(TagsActions.deleteTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
